
export const USER_URI = 'https://xml.cloudcodice.com/feature/company/User/1.1.0';

export class CompanyUser {
    userId?: string;
    companyId?: string;
    userPrincipalName?: string;
    cn?: string;
    sAMAccountName?: string;
    externalCode?: string;
    uri?: string;
    displayName?: string;
    fromDate?: string;
    toDate?: string;
    preferredLanguage?: string;
    profileImage?: string;
    telephoneNumber?: string;
    enabled?: boolean;
    payload?: any;
}